import { compose, lifecycle } from 'recompose';

import connect from 'app/libs/connect';

function componentDidMount() {
  this.props.action(this.props);
}

const withDispatchOnMount = action =>
  compose(connect(null, { action }), lifecycle({ componentDidMount }));

export { componentDidMount };

export default withDispatchOnMount;
